/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAwardBlockFragment} from '@amblique/contentful/app/contentful/fragments/award-block/base-award-block.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';

export const AwardBlockFragment = gql`
  ${BaseAwardBlockFragment}
  ${BaseImageFragment}
  ${BaseRichTextBlockFragment}

  fragment AwardBlockFragment on AwardBlock {
    ...BaseAwardBlockFragment

    leftContentCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
      }
    }
    leftContentCursorCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
      }
    }
    rightContentCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
      }
    }
    rightContentCursorCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
      }
    }
  }
`;
